import { render, staticRenderFns } from "./ChemMcMPL4_Q9b.vue?vue&type=template&id=3842bd29&scoped=true&"
import script from "./ChemMcMPL4_Q9b.vue?vue&type=script&lang=js&"
export * from "./ChemMcMPL4_Q9b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842bd29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
